/* MONA: upload pending configurator snapshots to Cloudinary
   right before the user proceeds to checkout. Runs site-wide. */
(function() {
  var CLOUDINARY = {
    cloudName: 'djjskblqu',
    uploadPreset: 'Mona_Configurator'
  };

  function getPending() {
    try { return JSON.parse(localStorage.getItem('mona_pending_snapshots') || '{}'); }
    catch (e) { return {}; }
  }
  function setPending(obj) {
    try { localStorage.setItem('mona_pending_snapshots', JSON.stringify(obj)); }
    catch (e) {}
  }
  function dataUrlToBlob(dataUrl) {
    var arr = dataUrl.split(',');
    var mime = arr[0].match(/:(.*?);/)[1];
    var bstr = atob(arr[1]);
    var u8arr = new Uint8Array(bstr.length);
    for (var i = 0; i < bstr.length; i++) u8arr[i] = bstr.charCodeAt(i);
    return new Blob([u8arr], { type: mime });
  }

  async function uploadOne(buildId, dataUrl) {
    var blob = dataUrlToBlob(dataUrl);
    var formData = new FormData();
    formData.append('file', blob);
    formData.append('upload_preset', CLOUDINARY.uploadPreset);
    formData.append('folder', 'configurator-snapshots');
    formData.append('public_id', buildId);
    var res = await fetch(
      'https://api.cloudinary.com/v1_1/' + CLOUDINARY.cloudName + '/image/upload',
      { method: 'POST', body: formData }
    );
    if (!res.ok) throw new Error('Upload failed: ' + res.status);
    return res.json();
  }

  async function uploadAllPending() {
    var pending = getPending();
    var ids = Object.keys(pending);
    if (ids.length === 0) return;

    var tasks = ids.map(async function(buildId) {
      var entry = pending[buildId];
      if (!entry || !entry.dataUrl) return;
      try {
        await uploadOne(buildId, entry.dataUrl);
        var current = getPending();
        delete current[buildId];
        setPending(current);
      } catch (e) {
        console.warn('Mona snapshot upload failed:', buildId, e);
      }
    });
    await Promise.allSettled(tasks);
  }

  (function cleanup() {
    var SEVEN_DAYS = 7 * 24 * 60 * 60 * 1000;
    var now = Date.now();
    var current = getPending();
    var changed = false;
    Object.keys(current).forEach(function(k) {
      if (current[k].createdAt && (now - current[k].createdAt) > SEVEN_DAYS) {
        delete current[k];
        changed = true;
      }
    });
    if (changed) setPending(current);
  })();

  document.addEventListener('click', function(e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var trigger = t.closest('[name="checkout"], a[href*="/checkout"], button[type="submit"][name="checkout"]');
    if (!trigger) return;
    if (Object.keys(getPending()).length === 0) return;
    uploadAllPending();
  }, true);

  document.addEventListener('submit', function(e) {
    var form = e.target;
    if (!form || !form.action) return;
    if (!/\/(cart|checkout)/i.test(form.action)) return;
    if (Object.keys(getPending()).length === 0) return;
    uploadAllPending();
  }, true);
})();
